import React from 'react';
import { SwiperOptions } from 'swiper';
import { IProps, IChildElement } from 'components/SliderBoundless/types';
import Slider from 'components/Slider';

const SliderBoundless: React.FC<IProps> & IChildElement = (props) => {
  const config: SwiperOptions = {
    loop: true,
    breakpoints: {
      813: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      0: {
        slidesPerView: 1,
        spaceBetween: 0
      }
    }
  };

  return (
    <div className="slider-boundless">
      <Slider
        name={props.name}
        config={config}
      >
        {props.children}
      </Slider>
    </div>
  );
};

SliderBoundless.Item = Slider.Item;

export default SliderBoundless;
